import app from 'firebase/app';
import 'firebase/database';
import config from './firebase.config';

const firebase = {
  database: null,

  init() {
    app.initializeApp(config);
    firebase.database = app.database();
  },
  async loadData() {
    const snapshot = await firebase.database.ref('/db_root/content/pages').once('value');
    return snapshot.val();
  },
  async loadSettings() {
    const snapshot = await firebase.database.ref('/db_root/settings').once('value');
    return snapshot.val();
  }
};

export default firebase;
